package top.wcpe.allincore.dsl.ir.model.hud

import top.wcpe.allincore.dsl.ir.model.internal.ReadOnlyOrderedSet
import kotlin.jvm.JvmField

/**
 * HUD 元数据共享常量。
 *
 * 这些值会被 DSL 编译器、服务端 manifest 解析、客户端渲染层共同使用，集中定义可避免
 * layer / hide token 字符串在多模块中各自维护导致漂移。
 */
object HudMetaDefaults {

    /** 默认 HUD 渲染层级：沿用 fabric HudRenderCallback TAIL 的旧行为。 */
    const val LAYER_ABOVE_CHAT: String = "above_chat"

    /** 聊天框之下渲染。 */
    const val LAYER_BELOW_CHAT: String = "below_chat"

    /** vanilla HUD 之下渲染。 */
    const val LAYER_BELOW_VANILLA: String = "below_vanilla"

    /** 预留覆盖层；当前客户端与 above_chat 同入口渲染。 */
    const val LAYER_OVERLAY: String = "overlay"

    /** HUD 默认渲染层级。 */
    const val DEFAULT_LAYER: String = LAYER_ABOVE_CHAT

    /** HUD tick 默认节流间隔（毫秒），≈vanilla 1 tick；由 HudRenderHook 在每帧前比对决定是否执行。 */
    const val TICK_INTERVAL_MS: Long = 50L

    const val STACK_DOWN: String = "down"
    const val STACK_UP: String = "up"
    const val STACK_RIGHT: String = "right"
    const val STACK_LEFT: String = "left"

    const val VISIBILITY_HIDE: String = "hide"
    const val VISIBILITY_SHOW: String = "show"
    const val VISIBILITY_INTERACTION_ONLY: String = "interaction_only"
    const val VISIBILITY_ALLOW_LIST: String = "allow_list"
    const val VISIBILITY_DENY_LIST: String = "deny_list"

    /** 合法 HUD 渲染层级闭集。 */
    @JvmField
    val ALLOWED_LAYERS: Set<String> = ReadOnlyOrderedSet(
        linkedSetOf(
            LAYER_ABOVE_CHAT,
            LAYER_BELOW_CHAT,
            LAYER_BELOW_VANILLA,
            LAYER_OVERLAY,
        ),
    )

    /** 合法 HUD 堆叠方向闭集。 */
    @JvmField
    val ALLOWED_STACK_DIRECTIONS: Set<String> = ReadOnlyOrderedSet(
        linkedSetOf(
            STACK_DOWN,
            STACK_UP,
            STACK_RIGHT,
            STACK_LEFT,
        ),
    )

    /** 合法 HUD screen 可见策略闭集。 */
    @JvmField
    val ALLOWED_VISIBILITY_MODES: Set<String> = ReadOnlyOrderedSet(
        linkedSetOf(
            VISIBILITY_HIDE,
            VISIBILITY_SHOW,
            VISIBILITY_INTERACTION_ONLY,
            VISIBILITY_ALLOW_LIST,
            VISIBILITY_DENY_LIST,
        ),
    )

    /** 合法 vanilla HUD 隐藏 token 闭集。 */
    @JvmField
    val ALLOWED_HIDE_TOKENS: Set<String> = ReadOnlyOrderedSet(
        linkedSetOf(
            "hotbar", "crosshair", "effects", "playerHealth", "vehicleHealth",
            "vignette", "experienceBar", "jumpMeter", "selectedItem",
            "bossbar", "chat", "playerList", "subtitles",
        ),
    )
}
